/**
 * Placeholders for the Info tab panels. Both endpoints hit remote datasets and
 * can take a few seconds, so what the user stares at first is the placeholder:
 * it has to occupy the same space the real cards will, or the whole tab jumps
 * when the data lands.
 */

const BAR = 'rounded bg-slate-100 dark:bg-slate-800';

export function RequirementCardSkeleton() {
  return (
    <div className="card overflow-hidden animate-pulse">
      <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100 dark:border-slate-800">
        <div className={`w-10 h-10 rounded-full ${BAR}`} />
        <div className="space-y-1.5">
          <div className={`h-4 w-48 ${BAR}`} />
          <div className={`h-2.5 w-64 ${BAR}`} />
        </div>
      </div>

      {/* Widths only vary so the block doesn't read as a table. */}
      <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.4fr] divide-y md:divide-y-0 md:divide-x divide-slate-100 dark:divide-slate-800">
        {['w-28', 'w-40', 'w-48'].map(w => (
          <div key={w} className="px-5 py-4 space-y-2.5">
            <div className={`h-2 w-16 ${BAR}`} />
            <div className={`h-5 ${w} ${BAR}`} />
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between gap-2 px-5 py-3 border-t border-slate-100 dark:border-slate-800">
        <div className={`h-2.5 w-32 ${BAR}`} />
        <div className={`h-2.5 w-24 ${BAR}`} />
      </div>
    </div>
  );
}

/** Whole section: the country name isn't known until the data arrives either. */
export function CountryEssentialsSkeleton() {
  return (
    <section className="mb-10 animate-pulse">
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-9 h-9 rounded-xl ${BAR}`} />
        <div className={`h-5 w-56 ${BAR}`} />
      </div>
      <div className={`h-[54px] rounded-2xl mb-4 ${BAR}`} />

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {Array.from({ length: 8 }, (_, i) => (
          <div key={i} className="card p-4 flex flex-col justify-between min-h-[118px]">
            <div className="flex items-center justify-between">
              <div className={`h-2 w-16 ${BAR}`} />
              <div className={`w-7 h-7 rounded-lg ${BAR}`} />
            </div>
            <div className={`h-5 w-24 ${BAR}`} />
          </div>
        ))}
      </div>

      <div className={`h-2.5 w-56 mt-3 ${BAR}`} />
    </section>
  );
}
